import { Text } from '@monolithmtl/components'

const TextItem = ({ blok, children, ...props }) => {
  const { text } = blok ?? {}

  return <Text {...props}>{children || text}</Text>
}

export default TextItem
